import cx from 'classnames'
import NextImage, { StaticImageData } from 'next/legacy/image'

import { LinkButton } from '../buttons/Button'
import { PoweredBy } from '../PoweredBy'

import styles from './FillerModule.module.scss'

export interface FillerElementAction {
  link: string
  content: string
}

interface FillerModuleProps {
  title: string
  image?: string | StaticImageData
  action?: FillerElementAction
  showPoweredBy?: boolean
  className?: string | string[]
}

export const FillerModule: React.FC<FillerModuleProps> = ({
  title,
  children,
  image,
  action,
  showPoweredBy,
  className,
}) => {
  return (
    <div className={cx(styles.FillerModule, className)}>
      <div className={styles.Wrapper}>
        <div className={styles.Content}>
          <h1>{title}</h1>
          <div className={styles.TextContent}>{children}</div>
          {action && (
            <LinkButton
              type={'OutlineSecondary'}
              additionalClasses={styles.Action}
              content={action.content}
              href={action.link}
            />
          )}
        </div>
        {image && (
          <div className={styles.Image}>
            <NextImage src={image} layout="fill" objectFit="contain" />
          </div>
        )}
        {showPoweredBy && <PoweredBy className={styles.PoweredBy} />}
      </div>
    </div>
  )
}
